import { createIcon } from '@chakra-ui/icons';

export const Bookmark = createIcon({
  displayName: 'Bookmark',
  viewBox: '0 0 11 13',
  path: [
    <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.1494 11.0847C10.1494 11.6991 9.47356 12.0736 8.95256 11.748L5.87061 9.82178C5.61695 9.66324 5.2951 9.66324 5.04145 9.82178L1.95949 11.748C1.4385 12.0736 0.762695 11.6991 0.762695 11.0847V1.936C0.762695 1.28773 1.28776 0.762665 1.93603 0.762665H8.97603C9.62429 0.762665 10.1494 1.28773 10.1494 1.936V11.0847Z"
        stroke="currentColor"
        strokeWidth="1.52533"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>,
  ],
});
